import React from 'react'
import { Helmet } from 'react-helmet'
import { getLangFromPrefix } from 'utils/helpers'

type SeoProps = {
  title: string
  description: string
}

export const SEO = ({ title, description }: SeoProps) => {
  const lang = getLangFromPrefix(process.env.GATSBY_PREFIX || '/en-gb')

  return (
    <Helmet title={title} htmlAttributes={{ lang }}>
      <meta name="description" content={description} />
      <meta property="og:description" content={description} />
      <meta name="twitter:description" content={description} />
      <script>{`
            !function(t,e,n,s,a,c,i,o,p){t.AppsFlyerSdkObject=a,t.AF=t.AF||function(){
            (t.AF.q=t.AF.q||[]).push([Date.now()].concat(Array.prototype.slice.call(arguments)))},
            t.AF.id=t.AF.id||i,t.AF.plugins={},o=e.createElement(n),p=e.getElementsByTagName(n)[0],o.async=1,
            o.src="https://websdk.appsflyer.com?"+(c.length>0?"st="+c.split(",").sort().join(",")+"&":"")+(i.length>0?"af_id="+i:""),
            p.parentNode.insertBefore(o,p)}(window,document,"script",0,"AF","banners",{banners: {key: "30a432da-e353-45c0-8333-2e56f1c79b2b"}});
            // Smart Banners are by default set to the max z-index value, so they won't be hidden by the website elements. This can be changed if you want some website components to be on top of the banner.
            AF('banners', 'showBanner', { bannerZIndex: 1000, additionalParams: { p1: "v1", p2: "v2"}});
        `}</script>
      <script src="https://onelinksmartscript.appsflyer.com/onelink-smart-script-v2.0.1.js" />
    </Helmet>
  )
}
